import { render } from "./TermsOfUse.vue?vue&type=template&id=1b16c4bc&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=1b16c4bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b16c4bc"]])

export default __exports__